import { App } from 'vue';
import SoftTermBDE from './SoftTerm/SoftTermBDE.vue';
import SoftTermReisenDienstReiseBeginn from './SoftTerm/Reisen/DienstReiseBeginn.vue';
import SoftTermReisenDienstReiseEnde from './SoftTerm/Reisen/DienstReiseEnde.vue';
import BaseStammMaske from './Base/StammMaske.vue';
import BaseEditor from '@/components/BaseEditor.vue';
import BaseVGrid from '@/components/BaseVGrid.vue';
import BaseDruck from './Base/Druck.vue';
import ModellDialog from '@/components/ModellDialog.vue';
import PzePersoenlichPlanungenTemplatesDialog from './PZE/persoenlich/Planungen/Templates/Dialog.vue';
import PzePersoenlichPlanungenTemplatesStempelungen from './PZE/persoenlich/Planungen/Templates/Stempelungen.vue';
import PzePersoenlichPlanungenTemplatesDialogDetailantrag from './PZE/persoenlich/Planungen/Templates/DialogDetailantrag.vue';
import PzePersoenlichPlanungenTemplatesDialogFreigabeStellvertreter from './PZE/persoenlich/Planungen/Templates/DialogFreigabeStellvertreter.vue';
import RkMitarbeiterTemplateDialogReisen from './RK/Mitarbeiter/Template/DialogReisen.vue';
import PzeWfVorgesetzterFreigabenTemplateDialogFreigabe from './PZE/WFVorgesetzter/Freigaben/Template/DialogFreigabe.vue';
import PzeWfVorgesetzterFreigabenTemplateMonatlFreigabe from './PZE/WFVorgesetzter/Freigaben/Template/MonatlFreigabe.vue';
import PzeWfVorgesetzterFreigabenTemplateStempelungen from './PZE/WFVorgesetzter/Freigaben/Template/Stempelungen.vue';
import PzeWfVorgesetzterFreigabenTemplateDialogDetailantrag from './PZE/WFVorgesetzter/Freigaben/Template/DialogDetailantrag.vue';
import PzeWfVorgesetzterFreigabenTemplateMaUest from './PZE/WFVorgesetzter/Freigaben/Template/MAUest.vue';
import RkAdminDialogReisen from './RK/Admin/DialogReisen.vue';
import RkWfVorgesetzterDialogReisen from './RK/WFVorgesetzter/DialogReisen.vue';
import PzeWfVorgesetzterFreigabenTemplateDialogDienstplan from './PZE/WFVorgesetzter/Freigaben/Template/DialogDienstplan.vue';
import SoftTermTagesSalden from './SoftTerm/TagesSalden.vue';
import PzePersoenlichWfWorkflowSalden from './PZE/persoenlich/WF/WorkflowSalden.vue';
import SoftTermNacherfassung from './SoftTerm/Nacherfassung.vue';
import RkMitarbeiterTemplateAnzeigeReiseTimeLine from './RK/Mitarbeiter/Template/AnzeigeReiseTimeLine.vue';
import SoftTermProjektstundenProjektstunden from './SoftTerm/Projektstunden/Projektstunden.vue';
import SoftTermProjektstundenUebersicht from './SoftTerm/Projektstunden/Uebersicht.vue';
import RkMitarbeiterKostenersatz from "@/views/RK/Mitarbeiter/Kostenersatz.vue";
import RkMitarbeiterReiseUebersicht from "@/views/RK/Mitarbeiter/ReiseUebersicht.vue";
import RkMitarbeiterTemplateReiseStatus from "@/views/RK/Mitarbeiter/Template/ReiseStatus.vue";
import SoftTermBuchungen from './SoftTerm/Buchungen.vue';
import SoftTermStempelEdit from './SoftTerm/StempelEdit.vue';
import SoftTermStempelEditBde from './SoftTerm/StempelEditBDE.vue';
import SoftTermEditStempelantrag from './SoftTerm/EditStempelantrag.vue';
import SoftTermReisenEditReisen from './SoftTerm/Reisen/EditReisen.vue';
import SoftTermReisenGrenzuebertritt from './SoftTerm/Reisen/Grenzuebertritt.vue';
import DialogDienstplan from './PZE/WFVorgesetzter/Freigaben/Template/DialogDienstplanAbwesenheiten.vue';
import RkMitarbeiterEditKostenersatz from './RK/Mitarbeiter/EditKostenersatz.vue';
import RkMitarbeiterBeleg from './RK/Mitarbeiter/RkMitarbeiterBeleg.vue';
import SoftTermProjektstundenEdit from './SoftTerm/Projektstunden/Edit.vue';
import DvhEditAkquisition from '@/views/DVH/EditAkquisition.vue';
import DvhEditHotline from '@/views/DVH/EditHotline.vue';
import DashboardChartsDetailsPopUp from '@/components/dashboard/Charts/DetailsPopUp.vue';
import RkMitarbeiterSonstigeBelege from './RK/Mitarbeiter/sonstigeBelege.vue';
import BaseDialog from '@/components/BaseDialog.vue';
import RkMitarbeiterEditKmErfassung from "@/views/RK/Mitarbeiter/EditKmErfassung.vue";
import PzeWfVorgesetzterFreigabenTemplateDialogSonstigeBelege from './PZE/WFVorgesetzter/Freigaben/Template/DialogSonstigeBelege.vue';
import RkWfVorgesetzterDialogKosten from './RK/WFVorgesetzter/DialogKosten.vue';
import RkWfVorgesetzterReiseDatenDetails from './RK/WFVorgesetzter/ReiseDatenDetails.vue';
import RkWfVorgesetzterReiseDaten from './RK/WFVorgesetzter/ReiseDaten.vue';
import RkAdminDialogKosten from './RK/Admin/DialogKosten.vue';
import BasePassword from './Base/Password.vue';
import RkMitarbeiterEditKostenersatzGrid from './RK/Mitarbeiter/EditKostenersatzGrid.vue';
import RkMitarbeiterNewKostenersatzBelegTabelle from './RK/Mitarbeiter/NewKostenersatzBelegTabelle.vue';
import PzePersoenlichPlanungenAntraege from './PZE/persoenlich/Planungen/Antraege.vue';

import VTimeLineDay from '@/components/common/VTimeLineDay.vue';
import EditStamm from '@/components/EditStamm.vue';
import LogViewer from '@/components/LogViewer.vue';

export function registerAllViewComponents(app: App) {
    app.component('SoftTermBDE', SoftTermBDE);
    app.component('SoftTermReisenDienstReiseBeginn', SoftTermReisenDienstReiseBeginn);
    app.component('SoftTermReisenDienstReiseEnde', SoftTermReisenDienstReiseEnde);
    app.component('BaseStammMaske', BaseStammMaske);
    app.component('BaseEditor', BaseEditor);
    app.component('BaseVGrid', BaseVGrid);
    app.component('BaseDruck', BaseDruck);
    app.component('ModellDialog', ModellDialog);
    app.component('PzePersoenlichPlanungenTemplatesDialog', PzePersoenlichPlanungenTemplatesDialog);
    app.component('PzePersoenlichPlanungenTemplatesDialogFreigabeStellvertreter', PzePersoenlichPlanungenTemplatesDialogFreigabeStellvertreter);
    app.component('RkMitarbeiterTemplateDialogReisen', RkMitarbeiterTemplateDialogReisen);
    app.component('PzeWfVorgesetzterFreigabenTemplateDialogFreigabe', PzeWfVorgesetzterFreigabenTemplateDialogFreigabe);
    app.component('PzeWfVorgesetzterFreigabenTemplateStempelungen', PzeWfVorgesetzterFreigabenTemplateStempelungen);
    app.component('PzeWfVorgesetzterFreigabenTemplateDialogDetailantrag', PzeWfVorgesetzterFreigabenTemplateDialogDetailantrag);
    app.component('RkAdminDialogReisen', RkAdminDialogReisen);
    app.component('RkWfVorgesetzterDialogReisen', RkWfVorgesetzterDialogReisen);
    app.component('PzeWfVorgesetzterFreigabenTemplateDialogDienstplan', PzeWfVorgesetzterFreigabenTemplateDialogDienstplan);
    app.component('SoftTermTagesSalden', SoftTermTagesSalden);
    app.component('PzePersoenlichWfWorkflowSalden', PzePersoenlichWfWorkflowSalden);
    app.component('SoftTermNacherfassung', SoftTermNacherfassung);
    app.component('RkMitarbeiterTemplateAnzeigeReiseTimeLine', RkMitarbeiterTemplateAnzeigeReiseTimeLine);
    app.component('SoftTermProjektstundenProjektstunden', SoftTermProjektstundenProjektstunden);
    app.component('SoftTermProjektstundenUebersicht', SoftTermProjektstundenUebersicht);
    app.component('RkMitarbeiterKostenersatz', RkMitarbeiterKostenersatz);
    app.component('RkMitarbeiterReiseUebersicht', RkMitarbeiterReiseUebersicht);
    app.component('RkMitarbeiterTemplateReiseStatus', RkMitarbeiterTemplateReiseStatus);
    app.component('SoftTermBuchungen', SoftTermBuchungen);
    app.component('SoftTermStempelEdit', SoftTermStempelEdit);
    app.component('SoftTermStempelEditBde', SoftTermStempelEditBde);
    app.component('SoftTermEditStempelantrag', SoftTermEditStempelantrag);
    app.component('SoftTermReisenEditReisen', SoftTermReisenEditReisen);
    app.component('SoftTermReisenGrenzuebertritt', SoftTermReisenGrenzuebertritt);
    app.component('DialogDienstplan', DialogDienstplan);
    app.component('RkMitarbeiterEditKostenersatz', RkMitarbeiterEditKostenersatz);
    app.component('RkMitarbeiterBeleg', RkMitarbeiterBeleg);
    app.component('SoftTermProjektstundenEdit', SoftTermProjektstundenEdit);
    app.component('DvhEditAkquisition', DvhEditAkquisition);
    app.component('DvhEditHotline', DvhEditHotline);
    app.component('DashboardChartsDetailsPopUp', DashboardChartsDetailsPopUp);
    app.component('RkMitarbeiterSonstigeBelege', RkMitarbeiterSonstigeBelege);
    app.component('BaseDialog', BaseDialog);
    app.component('RkMitarbeiterEditKmErfassung', RkMitarbeiterEditKmErfassung);
    app.component('PzeWfVorgesetzterFreigabenTemplateDialogSonstigeBelege', PzeWfVorgesetzterFreigabenTemplateDialogSonstigeBelege);
    app.component('RkWfVorgesetzterDialogKosten', RkWfVorgesetzterDialogKosten);
    app.component('RkWfVorgesetzterReiseDatenDetails', RkWfVorgesetzterReiseDatenDetails);
    app.component('RkWfVorgesetzterReiseDaten', RkWfVorgesetzterReiseDaten);
    app.component('RkAdminDialogKosten', RkAdminDialogKosten);
    app.component('BasePassword', BasePassword);
    app.component('RkMitarbeiterEditKostenersatzGrid', RkMitarbeiterEditKostenersatzGrid);
    app.component('RkMitarbeiterNewKostenersatzBelegTabelle', RkMitarbeiterNewKostenersatzBelegTabelle);
    app.component('MonatlFreigabe', PzeWfVorgesetzterFreigabenTemplateMonatlFreigabe);
    app.component('PzePersoenlichPlanungenAntraege', PzePersoenlichPlanungenAntraege);
    app.component('PzePersoenlichPlanungenTemplatesStempelungen', PzePersoenlichPlanungenTemplatesStempelungen);
    app.component('PzePersoenlichPlanungenTemplatesDialogDetailantrag', PzePersoenlichPlanungenTemplatesDialogDetailantrag);
    app.component('PzeWfVorgesetzterFreigabenTemplateMaUest', PzeWfVorgesetzterFreigabenTemplateMaUest);



    app.component('VTimeLineDay', VTimeLineDay); // nur zum ausprobieren
    app.component('EditStamm', EditStamm); // nur zum ausprobieren
    app.component('LogViewer', LogViewer);
}